import { FaBookOpen, FaShieldAlt, FaWallet } from "react-icons/fa";
import { SecurityDashboardViewMain } from "../Components/SecurityDashboardViewMain";
import { ShelfDashboardViewMain } from "../Components/ShelfDashboardViewMain";
import { FinanceDashboardViewMain } from "../Components/FinanceDashboardViewMain";

export const WorkspaceModule = () => [
    {
        views: "PRIVATE", path: "/security", component: <SecurityDashboardViewMain />,
        roles: null, permissions: null, label: "Seguridad", icon: <FaShieldAlt />,
        displayInHeader: false, displayInFooter: false, displayInSidebar: false,
        isBlockedWhenLogged: false,
    },
    {
        views: "PRIVATE", path: "/shelf", component: <ShelfDashboardViewMain />,
        roles: null, permissions: null, label: "Estantería", icon: <FaBookOpen />,
        displayInHeader: false, displayInFooter: false, displayInSidebar: false,
        isBlockedWhenLogged: false,
    },
    {
        views: "PRIVATE", path: "/finance", component: <FinanceDashboardViewMain />,
        roles: null, permissions: null, label: "Finanzas", icon: <FaWallet />,
        displayInHeader: false, displayInFooter: false, displayInSidebar: false,
        isBlockedWhenLogged: false,
    },
];
